<div *ngIf="_statistics">
    <div *ngFor="let data of _statistics">
        <label>{{ data.time }}</label>
        <span class="ml-2">{{ data.brightness }}%</span>
    </div>
</div>